import { useState, createContext, useContext } from "react";

export const UploadContext = createContext();

export const UploadProvider = ({ children }) => {
    const [selected_ids, setSelected_ids] = useState([]);
    const [selected_uids, setSelected_uids] = useState([]);
    const [private_title, setPrivate_title] = useState('');

    return (
        <UploadContext.Provider value={{ selected_ids, setSelected_ids, selected_uids, setSelected_uids, private_title, setPrivate_title }}>
            {children}
        </UploadContext.Provider>
    );
};



export const useUpload = () => {
    const context = useContext(UploadContext);
    if (!context) {
        throw new Error("useUpload must be used within a UploadProvider");
    }
    return context;
}